import { Page } from "../../Components/Page/Page.component";
import { RemindersTable } from "./Reminders.table";

export const RemindersPage = () => {
  return (
    <Page title="Reminders">
      <RemindersTable />
    </Page>
  );
};
